import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconGenderFemale: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGenderFemale"><Circle cx="12" cy="8.5" r="6" stroke="currentColor"/><Path d="M12 14.5V21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 18.5H15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconGenderFemale;
